module.exports = "https://static.energy5.com/_next/static/images/brand0-72756ab85633da539d5412584a0cf479.png";